type NewValue<T> = [keyof T, any];

export const getDifferences = <T extends Record<string, any>>(prev: T, next: any): NewValue<T>[] =>
  Object.entries(prev).reduce((acc, [key, prevValue]) => {
    const nextValue = next[key];
    if (nextValue !== prevValue) acc.push([key, nextValue]);
    return acc;
  }, [] as NewValue<T>[]);

type ArrayDiff<T> = {
  added: T[];
  removed: T[];
};

export const arrayDiff = <T>(base: T[], next: T[], getValue: (cur: T) => keyof T | T): ArrayDiff<T> => {
  const added = next?.reduce((acc, cur) => {
    const foundInBase = base?.find((item) => getValue(item) === getValue(cur));
    if (foundInBase) return acc;

    return [...acc, cur];
  }, [] as T[]);

  const removed = base?.reduce((acc, cur) => {
    const foundInNext = next?.find((item) => getValue(item) === getValue(cur));
    if (foundInNext) return acc;

    return [...acc, cur];
  }, [] as T[]);

  return { added, removed };
};
